import * as z from "zod";
import type {
  PortalSettingsPatch,
  ReturnsPortalSettingsSource,
} from "./portal-settings-source";

export const displaySettingsShape = {
  display: z.object({ languageSupportEnabled: z.boolean() }),
};

export type DisplaySettings = z.infer<z.ZodObject<typeof displaySettingsShape>>;

export function displaySettingsFromTeam({
  settings,
}: ReturnsPortalSettingsSource): DisplaySettings {
  return {
    display: { languageSupportEnabled: !!settings.localization?.enabled },
  };
}

export function displayTeamPatch({
  display,
}: DisplaySettings): PortalSettingsPatch {
  return {
    set: { "localization.enabled": display.languageSupportEnabled },
    unset: [],
  };
}
